import { useCallback, useEffect, useRef } from "react";

import styles from "@styles/dropAuction/dropAuctionTimer.module.scss";

const CountdownTimer = (props) => {
  const {
    auctionStartTime,
    auctionNowTime,
    setDistance,
    isList = false,
    auctionId,
    counterVisiblity = false,
    isLoose = false,
    colorText = "moss",
  } = props;
  const timerRef = useRef({});
  const containerRef = useRef({});
  const getTimeLeft = useCallback(() => {
    let timeLeft = {};
    let distance = 0;
    if (!timerRef.current[auctionId.toString() + "ref"]) {
      timerRef.current[auctionId.toString() + "ref"] = {
        timer: { d: 0, h: 0, m: 0, s: 0, distance: 0, timerStarted: false },
        timeInterval: null,
      };
    }

    if (!timerRef.current[auctionId.toString() + "ref"]?.timer?.timerStarted) {
      const startTime = new Date(auctionStartTime).getTime();
      const now = new Date(auctionNowTime).getTime();
      distance = startTime - now;
    } else {
      distance = timerRef.current[auctionId.toString() + "ref"].timer.distance;
    }

    timerRef.current[auctionId.toString() + "timeInterval"] = setInterval(
      () => {
        timerRef.current[
          auctionId.toString() + "ref"
        ].timer.timerStarted = true;
        timeLeft = {
          d: Math.floor(distance / (1000 * 60 * 60 * 24)),
          h: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          m: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          s: Math.floor((distance % (1000 * 60)) / 1000),
          distance,
        };
        if (distance < 0) {
          clearInterval(
            timerRef.current[auctionId.toString() + "timeInterval"]
          );
        }
        distance = distance - 1000;
        timerRef.current[auctionId.toString() + "distance"] = distance;
        setDistance(distance);
        timerRef.current[auctionId.toString() + "ref"].timer = {
          d: timeLeft.d,
          h: timeLeft.h,
          m: timeLeft.m,
          s: timeLeft.s,
          distance,
        };
        let innerText = "";
        if (!isList) {
          innerText += `Auction Starts in `;
        }
        if (timeLeft.d > 0) {
          if (
            checkIsValueSame(
              auctionId.toString() + "d",
              `${("0" + timeLeft.d).slice(-2)}d`
            )
          ) {
            updateText(
              auctionId.toString() + "d",
              `${("0" + timeLeft.d).slice(-2)}d`,
              true
            );
          }
        }
        if (timeLeft.d + timeLeft.h > 0) {
          if (
            checkIsValueSame(
              auctionId.toString() + "h",
              `${("0" + timeLeft.h).slice(-2)}h`
            )
          ) {
            updateText(
              auctionId.toString() + "h",
              `${("0" + timeLeft.h).slice(-2)}h`,
              true
            );
          }
        } else {
          updateText(auctionId.toString() + "h", ``);
        }
        if (timeLeft.d + timeLeft.h + timeLeft.m > 0) {
          if (
            checkIsValueSame(
              auctionId.toString() + "m",
              `${("0" + timeLeft.m).slice(-2)}m`
            )
          )
            updateText(
              auctionId.toString() + "m",
              `${("0" + timeLeft.m).slice(-2)}m`,
              true
            );
        } else {
          updateText(auctionId.toString() + "m", ``);
        }
        if (timeLeft.d + timeLeft.h + timeLeft.m + timeLeft.s > 0) {
          if (
            checkIsValueSame(
              auctionId.toString() + "s",
              `${("0" + timeLeft.s).slice(-2)}s`
            )
          )
            updateText(
              auctionId.toString() + "s",
              `${("0" + timeLeft.s).slice(-2)}s`,
              false
            );
        } else {
          updateText(auctionId.toString() + "s", ``, false);
        }

        if (distance < 0) {
          if (!isList) {
            innerText = "Auction Starting Now";
          } else {
            innerText = "Auction In Progress";
          }
        }
        if (
          timerRef &&
          timerRef.current[auctionId.toString() + "other"] &&
          checkIsValueSame(auctionId.toString() + "other", innerText)
        ) {
          updateText(
            auctionId.toString() + "other",
            innerText,
            innerText === "Auction Starts in " ? false : true,
            !(timeLeft.d > 0)
          );
        }
      },
      1000
    );
  }, [
    timerRef,
    auctionId,
    auctionStartTime,
    auctionNowTime,
    setDistance,
    isList,
  ]);

  const updateText = (id, innerText, isColon = false, emptySpace = false) => {
    if (timerRef.current && timerRef.current[id])
      if (innerText !== "") {
        timerRef.current[id].innerText = innerText;
        if (isColon) {
          const newElement = document.createElement("span");
          newElement.innerText = !emptySpace ? ":" : " ";
          newElement.style.margin = "0 2px";
          timerRef.current[id].appendChild(newElement);
        }
      } else {
        timerRef.current[id].innerText = "";
        timerRef.current[id].style["min-width"] = "0px";
      }
  };

  const checkIsValueSame = (id, innerText) => {
    if (timerRef.current && timerRef.current[id])
      if (timerRef.current[id].innerText === innerText) {
        return false;
      } else {
        return true;
      }
  };

  useEffect(() => {
    getTimeLeft();
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      clearInterval(timerRef?.current[auctionId.toString() + "timeInterval"]);
    };
  }, [auctionId, getTimeLeft, timerRef]);

  useEffect(() => {
    if (counterVisiblity === true) {
      containerRef.current[auctionId.toString()].style.visibility = "hidden";
      containerRef.current[auctionId.toString()].style.height = "0px";
    } else {
      containerRef.current[auctionId.toString()].style.visibility = "visible";
      containerRef.current[auctionId.toString()].style.height = "auto";
    }
  }, [auctionId, counterVisiblity]);

  return (
    <div
      ref={(ref) => (containerRef.current[auctionId.toString()] = ref)}
      className={`${styles.auctionTimerHeading} ${
        isLoose ? styles.looseScreen : isList ? styles.center : ""
      }  ${styles[colorText]}`}
    >
      <span
        className={styles.auctionStart}
        ref={(ref) => (timerRef.current[auctionId.toString() + "other"] = ref)}
      >
        {" "}
      </span>
      <span
        className={styles.day}
        ref={(ref) => (timerRef.current[auctionId.toString() + "d"] = ref)}
      >
        {" "}
      </span>
      <span
        className={styles.hour}
        ref={(ref) => (timerRef.current[auctionId.toString() + "h"] = ref)}
      >
        {" "}
      </span>
      <span
        className={styles.min}
        ref={(ref) => (timerRef.current[auctionId.toString() + "m"] = ref)}
      >
        {" "}
      </span>
      <span
        className={styles.sec}
        ref={(ref) => (timerRef.current[auctionId.toString() + "s"] = ref)}
      >
        {" "}
      </span>
    </div>
  );
};

export default CountdownTimer;
